module.exports = __webpack_public_path__ + "d246e06f295b056e70b1bbae9fb20882.pdf";